import React from 'react'

const Place = (props) => {
    let place = props.places.find(item => item.id === props.id)

    if(place) {
        return (<span>{place.name}</span>)
    } else {
        return (<span>Ocupat</span>)
    }
}

export default Place


// WEBPACK FOOTER //
// ./src/components/places/Place.js